import { useRef } from 'react';
import styles from './TitleFlex.module.scss';
import animationStyles from 'components/commons/Animation/Animation.module.scss';
import useElementVisible from 'components/commons/Animation/useElementVisible';

interface Props {
  sectionTitle: {
    title: string;
    sub_title: string;
  };
  adjust?: boolean;
  adjustFill?: boolean;
  adjustWide?: boolean;
}

const TitleFlex: React.FC<Props> = ({ sectionTitle, adjust = false, adjustFill = false, adjustWide = false }) => {
  const titleEnRef = useRef<HTMLSpanElement>(null);
  const titleJaRef = useRef<HTMLSpanElement>(null);

  const isTitleEnVisible = useElementVisible(titleEnRef, 0.1);
  const isTitleJaVisible = useElementVisible(titleJaRef, 0.1);

  const titleClassName = `${styles.title} ${adjust ? styles.title_adjust : ''} ${
    adjustFill ? styles.title_adjust_fill : ''
  } ${adjustWide ? styles.title_adjust_wide : ''}`;

  return (
    <h3 className={titleClassName}>
      <span
        className={`${styles.title_en} ${animationStyles.fade} ${isTitleEnVisible ? animationStyles.fadeOn : ''}`}
        ref={titleEnRef}
      >
        {sectionTitle.title}
      </span>
      <span
        className={`${styles.title_ja} ${animationStyles.fade} ${isTitleJaVisible ? animationStyles.fadeOn3 : ''}`}
        ref={titleJaRef}
      >
        {sectionTitle.sub_title}
      </span>
    </h3>
  );
};

export default TitleFlex;
